export const SCRIBE_CONTEXT_CHART_NOTE_HELPER_LINES = [
  "Chart note updates are auto-included in Scribe context.",
  "Your additional notes are preserved and merged automatically."
] as const;

export const SCRIBE_CONTEXT_CHART_NOTE_REFRESH_MESSAGE =
  "New chart note updates are available.";

export const SCRIBE_CONTEXT_CHART_NOTE_REFRESH_BUTTON = "Refresh context";

export const SCRIBE_CONTEXT_SYNC_ERROR_MESSAGE =
  "Could not refresh scribe context. Please try again.";
